/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:02/07/2021
 @Time:16:16
 **/
require ('expose-loader?exposes=feather!feather-icons');